import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Fire, Gift, Confetti } from "@phosphor-icons/react";

export default function StreakCard({ onClaimed }) {
  const [status, setStatus] = useState(null);
  const [claiming, setClaiming] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get("/streak/status");
      setStatus(data);
    } catch {
      // ignore
    }
  };

  useEffect(() => {
    load();
  }, []);

  const claim = async () => {
    if (claiming) return;
    setClaiming(true);
    try {
      const { data } = await api.post("/streak/claim");
      toast.success(
        data.milestone
          ? `🎉 7-day milestone! +$${data.amount.toFixed(2)}`
          : `+$${data.amount.toFixed(2)} claimed! Streak: ${data.new_streak}`
      );
      load();
      onClaimed?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed to claim");
    } finally {
      setClaiming(false);
    }
  };

  if (!status) return null;

  return (
    <Card
      data-testid="streak-card"
      className="bg-gradient-to-br from-orange-500/15 via-[#121212] to-pink-500/10 border-orange-500/30"
    >
      <CardContent className="p-5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="w-14 h-14 rounded-2xl bg-orange-500/20 flex items-center justify-center">
            <Fire size={30} weight="fill" className="text-orange-400" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-widest font-bold text-orange-300">
              Daily bonus
            </p>
            <p className="font-heading text-2xl font-black text-white">
              {status.current_streak} day{status.current_streak === 1 ? "" : "s"} streak
            </p>
            <p className="text-xs text-white/60 mt-0.5">
              +${status.daily_bonus.toFixed(2)}/day • +${status.streak_7day_bonus.toFixed(2)} every 7 days
            </p>
          </div>
        </div>
        {status.can_claim_today ? (
          <Button
            data-testid="claim-daily-bonus-btn"
            onClick={claim}
            disabled={claiming}
            className="bg-orange-500 hover:bg-orange-600 text-white font-heading font-bold gap-2"
          >
            <Gift size={18} weight="fill" />
            Claim ${status.daily_bonus.toFixed(2)}
          </Button>
        ) : (
          <div className="flex items-center gap-2 text-emerald-400 font-heading font-bold">
            <Confetti size={20} weight="fill" />
            Claimed today
          </div>
        )}
      </CardContent>
    </Card>
  );
}
